export enum UserStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  PENDING = 'PENDING',
}

export type UpdateUserStatusDto = {
  status: UserStatus
}

/**
 * Converte o valor vindo da API para `UserStatus`.
 * TODO: alinhar números/strings com o contrato real do backend.
 * Mapeamento numérico provisório: 0 = ACTIVE (compat. com dados antigos), 1 = INACTIVE, 2 = PENDING.
 */
export function parseUserStatus(raw: unknown): UserStatus {
  if (
    raw === UserStatus.ACTIVE ||
    raw === UserStatus.INACTIVE ||
    raw === UserStatus.PENDING
  ) {
    return raw
  }
  if (typeof raw === 'string') {
    const u = raw.trim().toUpperCase()
    if (u === 'ACTIVE') return UserStatus.ACTIVE
    if (u === 'INACTIVE') return UserStatus.INACTIVE
    if (u === 'PENDING') return UserStatus.PENDING
  }
  if (typeof raw === 'number' && Number.isFinite(raw)) {
    switch (raw) {
      case 0:
        return UserStatus.ACTIVE
      case 1:
        return UserStatus.INACTIVE
      case 2:
        return UserStatus.PENDING
      default:
        break
    }
  }
  return UserStatus.ACTIVE
}
